import { useMutation } from 'react-query';
import { requestCardMutationFns } from '../../../helpers/requestCardMutationFns';

const useAddWarrantyDocsMutation = (options) =>
  useMutation(requestCardMutationFns.warrantyDocs, options);

export default useAddWarrantyDocsMutation;
